<ng-container *transloco="let t">
    <ion-refresher slot="fixed" (ionRefresh)="handleRefresh($event)">
        <ion-refresher-content></ion-refresher-content>
    </ion-refresher>
    <div class="main-content !p-0 order-detail-page-content">
        <!-- <us-breadcrumbs
            *ngrxLet="{ homePageUrl: homePageUrl$, order: order$ } as vm"
            [items]="[
                            { title: t('home'),routerLink: vm.homePageUrl },
                            { title: t('orders_list'), routerLink: RouteUtil.getOrdersRouteUrl() },
                            { title: t('order') + ' ' + vm.order?.order_code },
                        ]"
        >
        </us-breadcrumbs> -->
        @if (orderId(); as id) {
            <us-order-detail [orderId]="id"/>
        }
    </div>
</ng-container>
